import { BILLING_OPTIONS } from "../constants/averageRates";

export default function getBillingOption(hasPayedServices) {
  return hasPayedServices ? BILLING_OPTIONS.add : BILLING_OPTIONS.buy;
}
